const env = {
    ...import.meta.env,
    NODE_ENV: import.meta.env.MODE || '',
};

const BASE_URL = env.VITE_APP_BASE_URL || '';
const REDIRECT_URI = env.VITE_APP_REDIRECT_URL || '';
const AZURE_APP_ID = env.VITE_APP_AZURE_ID || '';
const TENANT_ID = env.VITE_APP_TENANT_ID || '';
const AD_GROUP_PREFIX = env.VITE_APP_AD_GROUP_PREFIX || '';
const VITE_APP_TRACKER_URL = env.VITE_APP_TRACKER_URL || '';
const VITE_APP_TRACKER_API_KEY = env.VITE_APP_TRACKER_API_KEY || '';
export {
    AD_GROUP_PREFIX, AZURE_APP_ID, BASE_URL, REDIRECT_URI, TENANT_ID, VITE_APP_TRACKER_URL, VITE_APP_TRACKER_API_KEY, env
};
